/**
 * nc-addons — afkrydsningsliste til Zusatzoptionen paa produktsiden.
 *
 * HVORFOR CUSTOM ELEMENT OG IKKE ET INLINE SCRIPT:
 * assets/product-recommendations.js henter Zusatzoptionen med AJAX og saetter dem
 * ind med `this.innerHTML = ...`. Script-tags i den indsatte HTML bliver ALDRIG
 * koert. Custom elements opgraderes derimod automatisk, naar de kommer i DOM'en -
 * derfor ligger logikken her, og filen indlaeses fra selve produktsiden.
 *
 * ADVARSEL: samme fil tjekker `recommendations.querySelector('.product-card')` og
 * FJERNER hele blokken, hvis den ikke findes. Derfor har markup'en et skjult
 * .product-card-element. Fjernes det, forsvinder Zusatzoptionen sporloest.
 *
 * Afkrydsning = laeg i kurv med det samme. Fluebenet fjernet = fjern linjen igen.
 * Kurven opdateres via temaets egen pubsub-kanal 'cart-update', saa antallet i
 * headeren foelger med; taelleren skrives ogsaa direkte som sikkerhedsnet.
 */
if (!customElements.get('nc-addons')) {
  customElements.define(
    'nc-addons',
    class NcAddons extends HTMLElement {
      connectedCallback() {
        if (this._klar) return;
        this._klar = true;
        this.addEventListener('change', this._vedSkift.bind(this));
        this.addEventListener('click', this._vedKlik.bind(this));
      }

      _vedKlik(e) {
        var knap = e.target.closest('[data-nc-details]');
        if (!knap) return;
        e.preventDefault();
        var raekke = knap.closest('.nc-addons__row');
        var tekst = raekke && raekke.querySelector('.nc-addons__desc');
        if (!tekst) return;
        var skalAabnes = tekst.hasAttribute('hidden');
        if (skalAabnes) {
          tekst.removeAttribute('hidden');
        } else {
          tekst.setAttribute('hidden', '');
        }
        knap.setAttribute('aria-expanded', skalAabnes ? 'true' : 'false');
      }

      _vedSkift(e) {
        var felt = e.target.closest('input[type="checkbox"][data-variant-id]');
        if (!felt) return;

        var id = felt.dataset.variantId;
        var raekke = felt.closest('.nc-addons__row');
        var ruter = (window.FoxTheme && FoxTheme.routes) || {};
        var tilfoejUrl = (ruter.cart_add_url || '/cart/add') + '.js';
        var aendrUrl = (ruter.cart_change_url || '/cart/change') + '.js';
        var self = this;

        felt.disabled = true;
        if (raekke) raekke.classList.add('is-busy');

        var krop = felt.checked
          ? { items: [{ id: Number(id), quantity: 1 }] }
          : { id: String(id), quantity: 0 };

        fetch(felt.checked ? tilfoejUrl : aendrUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(krop),
        })
          .then(function (svar) {
            if (!svar.ok) throw new Error('kurv-fejl');
            return svar.json();
          })
          .then(function () {
            return fetch((ruter.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (svar) {
            return svar.json();
          })
          .then(function (kurv) {
            self._opdaterAntal(kurv);
            try {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                source: 'nc-addons',
                cartData: kurv,
              });
            } catch (err) {
              /* temaet har ingen lytter - taelleren er allerede skrevet ovenfor */
            }
          })
          .catch(function () {
            // Rul afkrydsningen tilbage, saa den altid afspejler kurven.
            felt.checked = !felt.checked;
          })
          .then(function () {
            felt.disabled = false;
            if (raekke) raekke.classList.remove('is-busy');
          });
      }

      _opdaterAntal(kurv) {
        var antal = kurv && typeof kurv.item_count === 'number' ? kurv.item_count : null;
        if (antal === null) return;
        document.querySelectorAll('cart-count, .cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = antal;
          if (el.hasAttribute('aria-label')) el.setAttribute('aria-label', antal + ' Artikel');
        });
      }
    }
  );
}
